import { Organization } from '@generated/graphql';
import { calculateDateDifference } from '@helper-functions/calculateDateDifference';

export const getOrganizationExpirationData = (
  organizations: Organization[],
  organizationId: string,
) => {
  const workspaceOrganization = organizations.find(
    (organization) => organization.organizationId === organizationId,
  );
  const { days, hours } = calculateDateDifference(workspaceOrganization?.expirationDate);
  return {
    expirationDate: { days, hours },
    expired: workspaceOrganization?.expired || hours < 1,
  };
};
